import { db } from "../../../../config/firebase.config";
import create from "zustand";
import axios from "axios";
import { toast } from "react-toastify";
import { config } from "../alerts/index";
// @firebase/firestore
import {
  doc,
  setDoc,
  serverTimestamp,
  onSnapshot,
  collection,
} from "firebase/firestore";

export const useStore = create((set, get) => ({
  customer: null,
  allCustomers: [],
  fetchCustomer: async () => {
    try {
      const response = await axios.post(`/account/user`);
      set({ customer: response.data.customer });
    } catch (error) {
      return error;
    }
  },
  fetchCustomers: () => {
    let users = [];
    try {
      const usersCollectionRef = collection(db, "users");

      onSnapshot(usersCollectionRef, (snapshot) => {
        if (users.length > 0) {
          users.splice(0, users.length);
        }
        snapshot.docs.map((doc) => {
          let item = {
            ...doc.data(),
          };

          users.push(item);
        });
      });

      set({
        allCustomers: users,
      });
      return users;
    } catch (error) {
      return error;
    }
  },
  register: async (payload) => {
    try {
      await axios.post(`/account/register`, payload);
      await axios.post(`/account/login`, {
        email: payload.email,
        password: payload.password,
      });
      const response = await axios.post(`/account/user`);
      localStorage.setItem("customer", JSON.stringify(response.data.customer));
      set({ customer: response.data.customer });
      const id = get().customer.id;
      setDoc(doc(db, "users", id.split("Customer/").pop()), {
        id: id,
        email: get().customer.email,
        firstName: get().customer.firstName,
        lastName: get().customer.lastName,
        cart: [],
        createdAt: serverTimestamp(),
        lastModified: serverTimestamp(),
      });
      toast("You have been registered", { ...config, type: "success" });
    } catch (error) {
      toast(error.message, { ...config, type: "error" });
      return error.message;
    }
  },
  edit: async (payload) => {
    try {
      await axios.put(`/account/user`, payload);
      const customer = {
        ...payload,
        id: get().customer.id,
      };
      localStorage.setItem("customer", JSON.stringify(customer));
      set({ customer });
      setDoc(
        doc(db, "users", customer.id.split("Customer/").pop()),
        {
          email: get().customer.email,
          firstName: get().customer.firstName,
          lastName: get().customer.lastName,
          lastModified: serverTimestamp(),
        },
        { merge: true }
      );
      toast("Your profile is successfully updated", {
        ...config,
        type: "success",
      });
    } catch (error) {
      toast("Issues updating your profile", { ...config, type: "error" });
      return error;
    }
  },
  login: async (payload) => {
    try {
      await axios.post(`/account/login`, payload.payload);
      const response = await axios.post(`/account/user`);
      set({ customer: response.data.customer });
      localStorage.setItem("customer", JSON.stringify(response.data.customer));

      toast("You are logged in", { ...config, type: "success" });
      payload.setCorrect(true);
    } catch (error) {
      payload.setCorrect(false);
      if (error.message.includes(401)) {
        toast("Incorrect Login Details", { ...config, type: "error" });
      } else {
        toast(error.message, { ...config, type: "error" });
      }

      return error.message;
    }
  },
  logout: async () => {
    try {
      axios.delete(`/account/user`);
      set({ customer: null });
      localStorage.clear();
      toast("You have logged out", { ...config, type: "success" });
    } catch (error) {
      return error.message;
    }
  },
  recovery: async (payload) => {
    try {
      const response = axios.post(`/reset`, payload);
      toast("Please check your emails", { ...config, type: "success" });
      return response;
    } catch (error) {
      return error.message;
    }
  },
}));
